import Contact from './sections/Contact';

(function() {
  'use strict'

  new Contact();

})();
